var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMergeEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.473 6.988.16 10.756a.666.666 0 0 0-.111.68c.093.23.303.378.537.378H2.34v3.349c0 .462.349.837.78.837h1.56c.43 0 .78-.375.78-.837v-3.35h1.755c.233 0 .445-.148.537-.378a.664.664 0 0 0-.112-.68L4.325 6.988a.577.577 0 0 0-.852 0zm8.2 2.024L8.36 5.244a.666.666 0 0 1-.111-.68.587.587 0 0 1 .537-.378h1.755V.837c0-.462.349-.837.78-.837h1.56c.43 0 .78.375.78.837v3.35h1.755c.233 0 .445.148.537.378a.664.664 0 0 1-.112.68l-3.315 3.767c-.22.25-.63.25-.852 0z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeEvent);
export default __webpack_public_path__ + "static/media/merge-event.304f70a010684684079a72e9adc3ac50.svg";
export { ForwardRef as ReactComponent };